import {
  GzAutomaticActionSettingsWebComponent,
} from '../../automaticActionSettings/component/GzAutomaticActionSettingsWebComponent';
import { KillProcessSettings } from '../../../types';
import { customElement, property, query } from 'lit/decorators.js';
import { GridType } from '../../../../../../customRulesGrid/types';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { html, TemplateResult } from 'lit';
import { FontSizes, FontWeights } from '../../../../../../../types/common/types';
import { GzCheckboxWebComponent } from '../../../../../../../ui/gzCheckbox';
import { CSSResultGroup } from '@lit/reactive-element/css-tag';
import { styles } from '../view/styles';
import { convertRuleFromFrontendToBackendFormat } from '../../../../../../customRulesGrid/utils';

@customElement('gz-kill-process-automatic-action-settings')
export class GzKillProcessAutomaticActionSettingsWebComponent
  extends GzAutomaticActionSettingsWebComponent<KillProcessSettings>
{
  @property({ type: Object, attribute: false, reflect: false })
  public rule: any;

  @property({ type: Boolean, attribute: false, reflect: false })
  public isGZ: boolean;

  @property({ type: String, attribute: false, reflect: false })
  public gridType: GridType;

  @property({ type: Boolean, attribute: false, reflect: false })
  public areAutomaticActionsAvailable: boolean;

  @query('#include-parent')
  private includeParentCheckbox: GzCheckboxWebComponent;

  @query('#include-children')
  private includeChildrenCheckbox: GzCheckboxWebComponent;

  public static get styles(): CSSResultGroup {
    return styles;
  }

  protected getTitle(): string {
    return translateFn('Edit kill process configuration');
  }

  protected getDescription(): string {
    return translateFn('Terminate the process that triggered the detection.');
  }

  protected renderContent(): TemplateResult {
    return html`
      <custom-rules-rule-outcome
        class="section mt-3"
        .rule=${convertRuleFromFrontendToBackendFormat(this.rule, this.gridType, this.areAutomaticActionsAvailable)}
        .isGZ=${this.isGZ}
        .gridType=${this.gridType}
        .displayDoTheFollowingSection=${false}
        .displayShowButtons=${true}
      >
      </custom-rules-rule-outcome>

      <gz-title
        class="section-title text-uppercase mb-2"
        fontweight="${FontWeights.SEMIBOLD}"
        fontsize="${FontSizes.PARAGRAPH_11}"
      >
        ${translateFn('Action configuration')}
      </gz-title>

      <gz-labeled-content
        class="mt-3"
        label=${translateFn('Application')}
        labelFontSize="${FontSizes.PARAGRAPH_13}"
        hasColon
      >
        <gz-checkbox
          id="include-parent"
          label="${translateFn('Include parent process')}"
          ?checked="${this.settings.includeParent}"
        >
        </gz-checkbox>
        <gz-checkbox
          id="include-children"
          class="mt-2"
          label="${translateFn('Include child processes')}"
          ?checked="${this.settings.includeChildren}"
        >
        </gz-checkbox>
      </gz-labeled-content>
    `;
  }

  protected editAction(): void {
    this.settings.includeParent = this.includeParentCheckbox.getFormValue();
    this.settings.includeChildren = this.includeChildrenCheckbox.getFormValue();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-kill-process-automatic-action-settings': GzKillProcessAutomaticActionSettingsWebComponent;
  }
}
